import { GeolocationApi } from '../../api/Geolocation'

export const findAddress = async (lat: number, lng: number) => {
  try {
    return await GeolocationApi.loadFirst(lat, lng)
  } catch (error) {
    return null
  }
}
